import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.array.find";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.split";
export var setting = {
  // 暨南大学学校内网环境配置
  jnu: {
    cName: 'outLogin',
    loginBg: require('@/assets/images/jd_bg_img.png'),
    // factoryRegisterUrl: 'https://yqwx.jnu.edu.cn/shfws/#/register',
    // factoryLoginUrl: 'https://yqwx.jnu.edu.cn/shfws/#/login',
    loginUrl: 'https://yqwx.jnu.edu.cn/api/ysa-jnuauth-service/jnuCasAuth/login',
    logoutUrl: 'https://icas.jnu.edu.cn/cas/logout?service=https://yqwx.jnu.edu.cn/api/ysa-jnuauth-service/jnuCasAuth/login',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // https://yqwx.jnu.edu.cn/dashboard，该学校有部署数据大屏，但是学校合同没有规定，所以注释掉
    // notShowPassBtn: true,
    source: '10559',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#1a7988',
      // 背景颜色
      $gradationColor: '#005D6C',
      // navbar渐变开始颜色
      $tintColor: '#EAFAFC' // 浅色背景
    }
  },
  // 海南大学学校内网环境配置
  hainanu: {
    cName: 'outLogin',
    loginBg: require('@/assets/images/hainanLogo/hd_bg.png'),
    // factoryRegisterUrl: 'https://yqwx.ilabeco.com/hainanu_shfws/#/register',
    // factoryLoginUrl: 'https://yqwx.ilabeco.com/hainanu_shfws/#/login',
    loginUrl: 'https://authserver.hainanu.edu.cn/authserver/login?service=https://yqyw.hainanu.edu.cn/api/ysa-hnuauth-service/hnuCasAuth/login',
    logoutUrl: 'https://yqyw.hainanu.edu.cn/api/ysa-hnuauth-service/hnuCasAuth/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // https://yqyw.hainanu.edu.cn/dashboard，该学校有部署数据大屏，但是学校合同没有规定，所以注释掉
    // notShowPassBtn: true,
    source: '10589',
    projectDesc: '实验室仪器售后服务保障系统',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#105398',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 海南医学院学校内网环境配置
  hainmc: {
    cName: 'outLogin',
    loginBg: require('@/assets/images/hainanyLogo/hainany_bg.png'),
    // factoryRegisterUrl: 'http://hainmc.ilabeco.com/shfws/#/register',
    // factoryLoginUrl: 'http://hainmc.ilabeco.com/shfws/#/login',
    loginUrl: 'http://210.37.77.89/api/ysa-hainmcauth-service/hainmcAuth/pcLogin',
    logoutUrl: '',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // notShowPassBtn: true,
    source: '11810',
    projectDesc: '实验室仪器售后服务保障系统',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#105398',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 海洋大学学校内网环境配置
  /*gdou: {
    cName: 'outLogin',
    loginBg: require('@/assets/images/haiyangLogo/bg.png'),
    // factoryRegisterUrl: 'https://yqwx.ilabeco.com/gdou_shfws/#/register',
    // factoryLoginUrl: 'https://yqwx.ilabeco.com/gdou_shfws/#/login',
    loginUrl: 'https://iasss.gdou.edu.cn/api/ysa-gdouauth-service/gdouCasAuth/login',
    logoutUrl: 'https://authserver.gdou.edu.cn/authserver/logout?service=https://iasss.gdou.edu.cn/api/ysa-gdouauth-service/gdouCasAuth/login',
    production: { VUE_APP_AFTER_SALES_URL: '' }, // 该学校没有部署数据大屏
    // notShowPassBtn: true,
    source: '10566',
    projectDesc: '实验室仪器售后服务保障系统',
    themeColors: {
      $bg: '#409EFF', // 背景颜色
      $gradationColor: '#105398', // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },*/
  // 云南大学学校环境配置
  yndxzs: {
    cName: 'outLogin',
    loginBg: require('@/assets/images/yndxzsLogo/bg.jpg'),
    // factoryRegisterUrl: 'http://yndxzs.ilabeco.com/shfws/#/register',
    // factoryLoginUrl: 'http://yndxzs.ilabeco.com/shfws/#/login',
    loginUrl: '',
    logoutUrl: '',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // notShowPassBtn: false,
    source: '10673',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#105398',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 华师学校环境配置
  scnu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 1899,
    tenantName: '华南师范大学',
    loginBg: require('@/assets/images/hnsfLogo/bg.jpg'),
    // factoryRegisterUrl: '',
    // factoryLoginUrl: '',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // notShowPassBtn: true,
    source: '10574',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#105398',
      // 背景颜色
      $gradationColor: '#409EFF',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 交通大学
  xjtu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 2060,
    tenantName: '西安交通大学',
    loginBg: require('@/assets/images/xjtuLogo/bg.jpeg'),
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 五邑大学
  wyu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 2395,
    tenantName: '五邑大学',
    loginBg: require('@/assets/images/wyuLogo/bg.jpg'),
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 四川大学
  iemsp: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 2439,
    tenantName: '四川大学',
    loginBg: require('@/assets/images/sichuan/bg.jpg'),
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护服务平台',
    themeColors: {
      $bg: '#ba2a17',
      // 背景颜色
      $gradationColor: '#ba2a17',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 海洋大学
  gdou: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 1318,
    tenantName: '广东海洋大学',
    loginBg: require('@/assets/images/haiyangLogo/bg.png'),
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '科研仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 哈尔滨工程大学
  hrbeu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 2815,
    tenantName: '哈尔滨工程大学',
    loginBg: require('@/assets/images/hrbeuLogo/bg.jpg'),
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    isDiscriminatePort: true,
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 广州中医药大学
  gzucm: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 4877,
    tenantName: '广州中医药大学',
    loginBg: 'http://yqwx.gzucm.edu.cn/images/login-bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    repairBatchTempDir: '/gzucm',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 中国矿业大学
  cumt: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 4888,
    tenantName: '中国矿业大学',
    loginBg: 'http://sbwx.cumt.edu.cn/images/login-bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 华南理工大学
  scut: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 5044,
    tenantName: '华南理工大学',
    loginBg: 'https://wx.zc.scut.edu.cn/images/login-bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    repairBatchTempDir: '/scut',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 中国科学院长春应用化学研究所ip
  ciacip: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 7696,
    tenantName: '中国科学院长春应用化学研究所',
    loginBg: 'http://10.10.31.82/images/bg.jpg',
    loginUrl: '',
    logoutUrl: '',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 中国科学院长春应用化学研究所外网
  ciac: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 7696,
    tenantName: '中国科学院长春应用化学研究所',
    loginBg: 'https://repair.ciac.ac.cn/images/bg.jpg',
    loginUrl: ['/api/ysa-clientauth-service/login', '/ysa-clientauth-service/technologyLogin'],
    logoutUrl: ['/api/ysa-clientauth-service/logout', '/api/ysa-clientauth-service/logout'],
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    outLoginName: ['应化e家认证登录', '中国科技网通行证登录'],
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 中检协
  ciqa: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 5069,
    tenantName: '中国检验检疫协会',
    loginBg: require('@/assets/images/login/login-bg.png'),
    loginUrl: '',
    logoutUrl: '',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 北师大
  bnu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 4523,
    tenantName: '北京师范大学',
    loginBg: 'http://172.24.125.96/images/login-bg.jpg',
    // 'http://yqwx.bnu.edu.cn/images/login-bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    isDiscriminatePort: true,
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 南昌大学
  ncu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 2491,
    tenantName: '南昌大学',
    loginBg: 'http://222.204.4.123/images/bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    isDiscriminatePort: true,
    repairBatchTempDir: '/ncu',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 吉首大学
  jsu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 5568,
    tenantName: '吉首大学',
    loginBg: 'http://192.168.253.214/images/bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    isDiscriminatePort: true,
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 广州医科大学
  gzhmu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 5761,
    tenantName: '广州医科大学',
    loginBg: 'https://limp.gzhmu.edu.cn/images/bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    isDiscriminatePort: true,
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 中山大学生产环境
  sysu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 2678,
    tenantName: '中山大学',
    loginBg: 'https://sbwx.sysu.edu.cn/images/bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    isDiscriminatePort: true,
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 中山大学
  zd: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 2678,
    tenantName: '中山大学',
    loginBg: 'http://10.16.4.181:52590/images/bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    isDiscriminatePort: true,
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 中山大学测试环境
  zdtest: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 2678,
    tenantName: '中山大学',
    loginBg: 'http://172.22.43.162:52780/images/bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    isDiscriminatePort: true,
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  jxuuwx: {
    env: 'cloud',
    cName: 'outLogin',
    tenantId: null,
    tenantName: '江西省高校',
    loginBg: require('@/assets/images/login/login-bg.png'),
    loginUrl: '',
    logoutUrl: '',
    test: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://192.168.4.96:8081/，其他环境展示屏蔽掉数据大屏
    testing: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://192.168.4.119:8081/，测试环境打包展示屏蔽掉数据大屏
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://aftersale.dc.ilabeco.com/，正式环境打包展示屏蔽掉数据大屏
    source: '10000',
    projectDesc: '科学仪器维修维护平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 兰州大学
  lzu: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 7904,
    tenantName: '兰州大学',
    loginBg: 'https://lzu.1751wuyou.com/images/bg.jpg',
    loginUrl: '',
    logoutUrl: '',
    showWxLogin: true,
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 内蒙古民族大学
  imun: {
    env: 'local',
    cName: 'outLogin',
    tenantId: 8126,
    tenantName: '内蒙古民族大学',
    loginBg: 'http://yqsbwx.imun.edu.cn/images/login-bg.jpg',
    loginUrl: '/api/ysa-clientauth-service/login',
    logoutUrl: '/api/ysa-clientauth-service/logout',
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    source: '',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#004e97',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 默认云环境
  saas: {
    env: 'cloud',
    // cloud：云 local:本地
    cName: 'outLogin',
    // 布局样式
    tenantId: 2334,
    tenantName: '维修维护平台',
    loginBg: require('@/assets/images/login/login-bg.png'),
    // 登录页面背景，后面换成接口返回
    loginUrl: '',
    logoutUrl: '',
    test: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://192.168.4.96:8081/，其他环境展示屏蔽掉数据大屏
    testing: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://192.168.4.119:8081/，测试环境打包展示屏蔽掉数据大屏
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://aftersale.dc.ilabeco.com/，正式环境打包展示屏蔽掉数据大屏
    source: '10000',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      // 后面换成接口返回
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#105398',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 无配置
  def: {
    env: 'cloud',
    // cloud：云 local:本地
    cName: 'outLogin',
    // 布局样式
    tenantId: 2334,
    tenantName: '维修维护平台',
    loginBg: require('@/assets/images/login/login-bg.png'),
    // 登录页面背景，后面换成接口返回
    loginUrl: '',
    logoutUrl: '',
    test: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://192.168.4.96:8081/，其他环境展示屏蔽掉数据大屏
    testing: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://192.168.4.119:8081/，测试环境打包展示屏蔽掉数据大屏
    production: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://aftersale.dc.ilabeco.com/，正式环境打包展示屏蔽掉数据大屏
    source: '10000',
    projectDesc: '仪器设备维修维护管理平台',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#105398',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  },
  // 开发本地环境、测试环境
  localhost: {
    env: 'cloud',
    // cloud：云 local:本地
    cName: 'outLogin',
    // 布局样式
    tenantId: 1213,
    tenantName: '西安职业技术学校',
    loginBg: require('@/assets/images/login/login-bg.png'),
    // 登录页面背景，后面换成接口返回
    loginUrl: '',
    logoutUrl: '',
    showWxLogin: true,
    test: {
      VUE_APP_AFTER_SALES_URL: ''
    },
    // http://192.168.4.96:8081/，其他环境展示屏蔽掉数据大屏
    testing: {
      // 测试环境
      VUE_APP_AFTER_SALES_URL: '',
      // http://192.168.4.119:8081/，测试环境打包展示屏蔽掉数据大屏
      mountingsDetailsUrl: 'http://test.1751wuyou.com' // 工程师小程序跳转地址
    },
    production: {
      // 生产环境
      VUE_APP_AFTER_SALES_URL: '',
      // http://aftersale.dc.ilabeco.com/，正式环境打包展示屏蔽掉数据大屏
      mountingsDetailsUrl: 'http://admin.1751wuyou.com' // 工程师小程序跳转地址
    },
    source: '10000',
    projectDesc: '仪器设备维修维护管理平台',
    repairBatchTempDir: '/ncu',
    themeColors: {
      $bg: '#409EFF',
      // 背景颜色
      $gradationColor: '#105398',
      // navbar渐变开始颜色
      $tintColor: '#E0EFFF' // 浅色背景
    }
  }
};

// ip地址绑定学校配置
var IPList = [{
  ipAddress: '192.168.4.96',
  domainName: 'localhost'
}, {
  ipAddress: '192.168.10.200',
  domainName: 'localhost'
}, {
  ipAddress: '10.10.31.82',
  domainName: 'ciacip'
}, {
  ipAddress: '159.226.166.20',
  domainName: 'ciac'
}, {
  ipAddress: '210.37.77.89',
  domainName: 'hainmc'
}, {
  ipAddress: '192.168.4.196',
  domainName: 'hainmc'
}, {
  ipAddress: '192.168.30.13',
  domainName: 'hrbeu'
}, {
  ipAddress: '192.168.145.102',
  domainName: 'gzucm'
}, {
  ipAddress: '172.24.125.96',
  domainName: 'bnu'
}, {
  ipAddress: '222.204.4.123',
  domainName: 'ncu'
}, {
  ipAddress: '192.168.253.214',
  domainName: 'jsu'
}, {
  ipAddress: '10.168.188.69:8090',
  domainName: 'gzhmu'
}, {
  ipAddress: '10.16.4.181:52590',
  domainName: 'zd'
}, {
  ipAddress: '172.22.43.162:52780',
  domainName: 'zdtest'
}];
var getProject = function getProject() {
  var arry = window.location.hostname.split('.');
  var names = [];
  var res = null;
  for (var i in setting) {
    names.push(i);
  }
  names.forEach(function (i, k) {
    if (arry.includes(i)) res = i;
  });
  console.log(arry);
  if (!res) {
    res = getIPProject();
  }
  return res;
};
var getProjectByTenantId = function getProjectByTenantId(tenantId) {
  var names = [];
  var res = null;
  for (var i in setting) {
    names.push(i);
  }
  names.forEach(function (i, k) {
    if (setting[i].tenantId === tenantId) res = i;
  });
  return res;
};

// 根据学校内网ip匹配
var getIPProject = function getIPProject() {
  var path = window.location.href.split('#')[0];
  var schoolSett = IPList.find(function (item) {
    return path.includes(item.ipAddress);
  });
  return schoolSett ? schoolSett.domainName : null;
};
export var pro = getProject();
export var proByTenantId = getProjectByTenantId;